import Header from "./components/header";
import Router from "./router.js";
import Footer from "./components/footer";
const App = () => {
  return (
    <>
      <Header />
      <Router />
      <Footer />
    </>
  );
};

export default App;
